export abstract class ISchiltzFacebookService {
    public abstract Share(link:string):Promise<void>;
}

export class FakeSchiltzFacebookService implements ISchiltzFacebookService{
    public Share(link: string):Promise<void>{
        return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/facebook/ISchiltzFacebookService.ts